import { render, staticRenderFns } from "./buynow.vue?vue&type=template&id=5a31c6b6"
import script from "./buynow.vue?vue&type=script&lang=js"
export * from "./buynow.vue?vue&type=script&lang=js"
import style0 from "./buynow.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./vue-slick-carousel.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "../../../../LrpRetailer/code/Scripts/components/lrp-retailer.scss?vue&type=style&index=2&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports